export default "__VITE_ASSET__DenVaesM__"